import { createFileRoute } from '@tanstack/react-router'
import { AdminHomePage } from '@/features/overview/pages/admin-home-page'

export const Route = createFileRoute('/')({
  staticData: { title: 'Overview' },
  component: AdminHomePage,
})
